import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import {computed} from 'vue';
import SearchResultsHeader from 'components/search/SearchResultsHeader.vue';
import SearchTablePane from 'components/search/SearchTablePane.vue';
import SearchResultsList from 'components/search/SearchResultsList.vue';
import {useSearchStore} from 'stores/search-store';
import { useLayoutStore } from 'stores/layout-store';
import { GrouperLayoutMode } from 'src/services/IodineGrouperService';

export default /*#__PURE__*/_defineComponent({
  __name: 'SearchResultsPane',
  setup(__props) {

const searchStore = useSearchStore();
const layoutStore = useLayoutStore();

const showSearchResultContentContainer = computed(() => {
  return !searchStore.isTableModeSelected || layoutStore.getLayoutMode == GrouperLayoutMode.fullScreen;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["search-results-pane full-width text-center min-height full-height", {'search-results-pane__no-flex': !showSearchResultContentContainer.value}])
  }, [
    _createVNode(SearchResultsHeader),
    (showSearchResultContentContainer.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["search-search-results-content-container min-height flex column full-width", {'iodine-scrollable-y': !_unref(searchStore).isTableModeSelected}])
        }, [
          (!_unref(searchStore).isTableModeSelected)
            ? (_openBlock(), _createBlock(SearchResultsList, { key: 0 }))
            : _createCommentVNode("", true),
          (_unref(searchStore).isTableModeSelected && _unref(layoutStore).getLayoutMode == _unref(GrouperLayoutMode).fullScreen)
            ? (_openBlock(), _createBlock(SearchTablePane, { key: 1 }))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}
}

})